export interface WaitlistSeatReadyDto {
  tableId: string;
  seat: number;
  stack: number;
  timeout: number;
}
